/**
 * @generated SignedSource<<32d93325a27852124b5d99365dc2cff4>>
 * @relayHash b2a8ea8d210999521cf3b649254b93b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b280819fb9c85b6d95763ed6f26cb6c023351042bc0addf09716d3b76423122a

import type { ConcreteRequest } from 'relay-runtime';
export type useStudioPermissionsLinkedWorkspaceQuery$variables = {
  siteAri: string;
};
export type useStudioPermissionsLinkedWorkspaceQuery$data = {
  readonly admin_unitLinkedResource: {
    readonly links: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
        } | null;
      }> | null;
    };
  } | null;
};
export type useStudioPermissionsLinkedWorkspaceQuery = {
  response: useStudioPermissionsLinkedWorkspaceQuery$data;
  variables: useStudioPermissionsLinkedWorkspaceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "siteAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "siteAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "atis": [
          "ati:cloud:studio:workspace"
        ]
      }
    },
    {
      "kind": "Literal",
      "name": "first",
      "value": 1
    }
  ],
  "concreteType": "AdminUnitLinkedConnection",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "concreteType": "AdminUnitLinkedEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "AdminUnitLinkedTo",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/)
          ]
        }
      ]
    }
  ],
  "storageKey": "links(filter:{\"atis\":[\"ati:cloud:studio:workspace\"]},first:1)"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useStudioPermissionsLinkedWorkspaceQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "AdminUnitLinkedResource",
        "kind": "LinkedField",
        "name": "admin_unitLinkedResource",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useStudioPermissionsLinkedWorkspaceQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "AdminUnitLinkedResource",
        "kind": "LinkedField",
        "name": "admin_unitLinkedResource",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "b2a8ea8d210999521cf3b649254b93b4",
    "id": "b280819fb9c85b6d95763ed6f26cb6c023351042bc0addf09716d3b76423122a",
    "metadata": {},
    "name": "useStudioPermissionsLinkedWorkspaceQuery",
    "operationKind": "query",
    "text": "query useStudioPermissionsLinkedWorkspaceQuery($siteAri:ID!){admin_unitLinkedResource(id:$siteAri){links(first:1,filter:{atis:[\"ati:cloud:studio:workspace\"]}){edges{node{id}}},id}}"
  }
};
})();

(node as any).hash = "29c062799a5b2c1f7df7d186f1b7b94b";

export default node;
